const AppConfig = {
  FILES_ENDPOINT: process.env.REACT_APP_FILES_ENDPOINT,
  APP_ENDPOINT: process.env.REACT_APP_ENDPOINT,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  API_VERSION: process.env.REACT_APP_API_VERSION,
  DEFAULT_DATE_FORMAT: process.env.REACT_APP_DEFAULT_DATE_FORMAT,
};

export default AppConfig;
